import {
  IconButton,
  InputBase,
  InputBaseProps,
  MenuItem,
  MenuItemTypeMap,
  Paper,
} from '@material-ui/core'
import { OverridableComponent } from '@material-ui/core/OverridableComponent'
import { Search as SearchIcon } from '@material-ui/icons'
import cx from 'clsx'
import { SVGProps, SyntheticEvent } from 'react'

import { Emphasize } from '../Emphasize'

import { FAQ } from './interface'

function CustomTextField({ InputProps }: { InputProps: InputBaseProps }) {
  return (
    <Paper className={cx('faq-search')} elevation={1}>
      <InputBase className="faq-search__input" {...InputProps} />
      <IconButton
        className={cx('faq-search-button', 'faq-search__icon-button')}
        aria-label="Search"
        type="submit"
      >
        <SearchIcon
          className="faq-search-icon"
          fontSize="large"
          component={(svgProps: SVGProps<SVGSVGElement>) => (
            <svg {...svgProps}>
              <defs>
                <linearGradient id="faq-search-gradient">
                  <stop offset="0" />
                  <stop offset="1" />
                </linearGradient>
              </defs>
              {svgProps.children}
            </svg>
          )}
        />
      </IconButton>
    </Paper>
  )
}

interface InputProps {
  InputProps: Omit<InputBaseProps, 'color' | 'onChange' | 'ref'>
}
export function renderInput(inputProps: InputProps) {
  return <CustomTextField InputProps={inputProps.InputProps} />
}

type MenuItemProps = OverridableComponent<
  MenuItemTypeMap<
    {
      button: false
    },
    'div'
  >
>
interface Props {
  suggestion: FAQ
  index: number
  highlightedIndex: number | null
  inputValue?: string | null
  itemProps: MenuItemProps
  onClick: (value: FAQ, state: { inputValue?: string | null }) => void
}
export function renderSuggestion({
  suggestion,
  index,
  itemProps,
  highlightedIndex,
  inputValue,
  onClick,
}: Props) {
  const isHighlighted = highlightedIndex === index
  // const isSelected = (selectedItem || '').indexOf(suggestion.title) > -1
  const handleClick = (e: SyntheticEvent) => {
    e.preventDefault()
    onClick(suggestion, { inputValue })
  }

  const { isSelected, ...props } = itemProps as any
  return (
    <MenuItem
      {...props}
      classes={{ selected: 'faq-search-item--selected' }}
      key={suggestion.id}
      selected={isHighlighted}
      component="div"
      style={{
        fontWeight: isSelected ? 500 : 400,
      }}
      onClick={handleClick}
    >
      <Emphasize target={suggestion.title} />
    </MenuItem>
  )
}
